import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CheckoutPaymentAdapter, PAYMENT_CARD_TYPE_NORMALIZER } from '@spartacus/checkout/base/core';
import { OccCheckoutPaymentAdapter } from '@spartacus/checkout/base/occ';
import {
  CardType,
  ConverterService,
  Occ,
  OccEndpointsService,
  PaymentDetails
} from '@spartacus/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

const ENDPOINT_CARD_TYPES = 'cardtypes';

export let headers = new HttpHeaders({
  'Content-Type': 'application/json',
});


@Injectable()
export class CustomOccCheckoutPaymentAdapter extends OccCheckoutPaymentAdapter implements CheckoutPaymentAdapter {
  constructor(
    protected http: HttpClient,
    protected occEndpoints: OccEndpointsService,
    protected converter: ConverterService
  ) {
    super(http, occEndpoints, converter);
  }

  protected getCartEndpoint(userId: string): string {
    const cartEndpoint = 'users/' + userId + '/carts/';
    return this.occEndpoints.buildUrl(cartEndpoint);
  }

  public createPaymentDetails(
    userId: string,
    cartId: string,
    paymentDetails: PaymentDetails
  ): Observable<any> {
    const address = paymentDetails.billingAddress;
    const url = this.getCartEndpoint(userId) + cartId + '/addresses/payment';
    return this.http.post<any>(url, { ...address }, { headers }).pipe(
      catchError((error: any) => throwError(error)),
      map((response: any) => response),
    );
  }

  public set(
    userId: string,
    cartId: string,
    paymentDetailsId: string
  ): Observable<any> {
    return this.http.put(
      this.getCartEndpoint(userId) + cartId + '/paymentdetails',
      {},
      {
        params: { paymentDetailsId },
      }
    );
  }

  loadCardTypes(): Observable<CardType[]> {
    return this.http
      .get<Occ.CardTypeList>(this.occEndpoints.buildUrl(ENDPOINT_CARD_TYPES))
      .pipe(
        map((cardTypeList) => cardTypeList.cardTypes),
        this.converter.pipeableMany(PAYMENT_CARD_TYPE_NORMALIZER)
      );
  }
}
